import { FirebaseApp } from 'firebase/app';

/**
 * 共通のFirebaseアプリインスタンス
 * 各プロジェクト（admin, school, town）で個別に初期化されている場合は、
 * そのアプリインスタンスを使用する必要があります。
 * 
 * 注意: このファイルは共通モジュール用です。
 * 各プロジェクトでFirebaseを初期化する場合は、プロジェクト固有の設定を使用してください。
 */

let firebaseApp: FirebaseApp | null = null;

/**
 * Firebaseアプリインスタンスを設定
 * 各プロジェクトから呼び出す必要があります
 */
export function setFirebaseApp(app: FirebaseApp): void {
  firebaseApp = app;
}

/**
 * Firebaseアプリインスタンスを取得
 * 設定されていない場合はエラーをスロー
 */
export function getFirebaseApp(): FirebaseApp {
  if (!firebaseApp) {
    throw new Error(
      'Firebase app is not initialized. Please call setFirebaseApp() first, ' +
      'or use project-specific firebase configuration.'
    );
  }
  return firebaseApp;
}

// デフォルトエクスポート（後方互換性のため）
export { getFirebaseApp as firebaseApp };

